import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "!rounded-md border-0" }

import Prism from 'prismjs';
import { ref, useSlots, watchEffect } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CodeBlock',
  props: {
  syntax: {
    type: String,
    default: 'dns-zone-file',
  },
},
  setup(__props) {

const slots = useSlots();
const code = ref<HTMLElement | null>(null);



watchEffect(() => {
  if (code.value && slots.default) {
    code.value.innerHTML = slots.default()[0].children?.toString() || '';
    Prism.highlightElement(code.value);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("pre", _hoisted_1, [
    _createElementVNode("code", {
      ref_key: "code",
      ref: code,
      class: _normalizeClass(`language-${__props.syntax}`)
    }, null, 2)
  ]))
}
}

})